var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"audio",attrs:{"type":"button","disabled":_vm.active || !_vm.wortos},on:{"click":_vm.onClick}},[_c('Icon'),_c('span',[_vm._v("Audio")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }